import { Component, OnInit, Input, OnChanges, ViewChild, HostListener } from '@angular/core';
import { SharedService } from '../../../shared/shared.service';
import { AppConstants } from '../../../config.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastService} from 'ng-uikit-pro-standard';
import { AuthService } from '../../../auth.service';
import { finalize } from 'rxjs/operators';
import { CommonDeleteModalComponent } from '../../../common/modals/common-delete-modal/common-delete'
import { ExceptionHandlingService } from '../../../shared/exception-handling.service';
declare var dhtmlx: any;

@Component({
  selector: 'customer-contacts',
  templateUrl: './customer-contacts.component.html',
  styles: [`
  .contacts-scrolling-div {
    max-height:120px;
    overflow-y:scroll;
  }

.card {
  border:1px solid #e9e9e9;
  box-shadow:unset !important;
  }
  .card.active {
    border-color:rgb(62, 189, 252);
  }
  .card-header {
  background-color:#f7f7f7;
  border-color:#e9e9e9;
  color:#555
  }

  .md-form {
    margin-bottom: 0px !important;
}

#models-container .trigger {
  background-color:#fff !important;
  width:30px;
  height:30px;
  border-radius:50%;
  font-size:14px;
  line-height:30px;
  text-align:center;
  border:1px solid #ccc !important;
}
.hidden {
  display:none;
}
.d-grid {margin-bottom:6px;}

  `]
})
export class CustomerContactsComponent implements OnInit, OnChanges {

  public accreditationContacts: any = [];

  @Input() accreditationItem: any;
  constructor(
    private service: SharedService,
    private appConstants: AppConstants,
    public toastr: ToastService,
    public translate: TranslateService,
    private authService: AuthService,
    private errorService: ExceptionHandlingService,
  ) { }

  truDeliveryContactAdd: boolean = false
  error: any = {};
  addClientContactsModalLoading: boolean = false
  modifyClientContactsModalLoading: boolean = false
  isSearchSectionOpen: boolean = true;
  ngOnChanges() {

    if (this.accreditationItem !== undefined) {
      if (this.accreditationItem.id) {
        this.authService.checkRoleExist('canAddContacts').then(res => this.truDeliveryContactAdd = res);
        this.getAccreditationContacts()
        this.isSearchSectionOpen = true;
      }
    }
  }

  ngOnInit() {}

  @HostListener('window:keydown', ['$event']) keyEvent(event: KeyboardEvent) {
    if (event.code == 'Escape') {
      if (this.addClientContactsModal && this.addClientContactsModal._isShown)
        this.checkIsModalDirty();
    }
  }

  contactsPageinfo:any={pageNumber:1,pageSize:10,isPaging:true}
  accreditationsContactsLoading : boolean = false;
  getAccreditationContacts() {
    this.accreditationsContactsLoading = true;
    this.service.post(this.appConstants.endPoints.accreditationsEndPoint + this.accreditationItem.id + '/query-contacts', {}, this.contactsPageinfo)
    .pipe(finalize(() => {
      this.accreditationsContactsLoading = false
    })).subscribe(data => {
        this.accreditationContacts = data && data.searchResults ? data.searchResults : [];
      });

  }
  
  searchName: string = '';
  public availableContacts: any = [];
  public clientDetails: any = { contact: {} };
  @ViewChild('addClientContactsModal', { static: true }) addClientContactsModal: any
  @ViewChild('addClientContactsModalForm', { static: true }) addClientContactsModalForm: any
  openAddClientContactsModal() {
    // this.accreditationItem = obj;
    this.resetClientContactsModal();
    this.resetPagnination();
    if(this.isSearchSectionOpen)
      this.getAvailableContacts();
    this.addClientContactsModal.show()
  }

  resetClientContactsModal() {
    this.error = {};
    this.isSearchSectionDirty = false;
    this.searchName = "";
    this.availableContacts = [];
    this.clientDetails = { contact: {} };
    this.addClientContactsModalForm.form.markAsPristine();
    this.addClientContactsModalForm.form.markAsUntouched();
  }

  onToggleContactModalSection(event, sectionType?) {
    if (event && event.state == 'expanded') {
      this.resetClientContactsModal();
      if (sectionType == 'serach-contacts') {
        this.isSearchSectionOpen = true;
        this.resetPagnination();
        this.getAvailableContacts();
      }
      else
        this.isSearchSectionOpen = false;
    }
  }

  pageInfo = {
    id: 'custom-contacts-pagination',
    itemsPerPage: 15,
    currentPage: 1,
    totalItems: 0,
    disablePagination: false
  };

  paginationChange(event) {
    this.pageInfo.currentPage = event
    this.getAvailableContacts();
  }

  resetPagnination() {
    this.pageInfo.currentPage = 1;
    this.pageInfo.itemsPerPage = 15;
    this.pageInfo.disablePagination = true;
  }


  getAvailableContacts() {
    let params = {}
    params['pageNumber'] = this.pageInfo.currentPage
    params['pageSize'] = this.pageInfo.itemsPerPage
    params['isPaging'] = true
    if (this.searchName)
      params['emailAddress'] = this.searchName
    this.addClientContactsModalLoading = true
    this.service.post(this.appConstants.endPoints.accreditationsEndPoint + this.accreditationItem.id + '/query-customer-contacts', {},params)
      .pipe(finalize(() => {
        this.addClientContactsModalLoading = false
      })).subscribe(data => {
        this.availableContacts = data && data.searchResults ? data.searchResults : [];
        this.searchName = ""
        this.availableContacts = this.availableContacts.map(res => {
          res['isSelected'] = false;
          return res;
        });
        if (data && data.pagingInfo && typeof data.pagingInfo == "object") {
          this.pageInfo.totalItems = data.pagingInfo.totalRows;
          this.pageInfo.disablePagination = false;
        }
        else {
          this.pageInfo.totalItems = this.availableContacts.length;
          this.pageInfo.disablePagination = true;
        }
      });
  }

  isExist() {
    if (this.addClientContactsModal._isShown && this.availableContacts && this.availableContacts.length) {
      let found = false;
      found = this.availableContacts.some(res => res.isSelected == true) ? false : true;      
      return found;
    }
  }


  addClientContact() {
    let modelSchema = {
      emailAddress: this.clientDetails.emailAddress,
      firstName: this.clientDetails.firstName,
      lastName: this.clientDetails.lastName,
      jobTitle: this.clientDetails.jobTitle,
      prefixName : this.clientDetails.prefixName,
      contactGenderType : {id:this.clientDetails.contactGenderType.id}
    }
    this.addClientContactsModalLoading = true
    this.service.post(this.appConstants.endPoints.accreditationsEndPoint + this.accreditationItem.id + '/contacts', {}, modelSchema)
      .pipe(finalize(() => {
        this.addClientContactsModalLoading = false
      })).subscribe(data => {
        this.addClientContactsModal.hide();
        this.getAccreditationContacts();
        this.toastr.success(this.translate.instant('administration_contactAdded_label'))
      },
        error => {
          this.errorService.errorHandling(error).then(res => {
            this.error = res;
          });
        });
  }

  saveSelectedContacts() {
    let selectedContacts = []
    for (let i = 0; i < this.availableContacts.length; i++) {
      if (this.availableContacts[i].isSelected == true) {
        selectedContacts.push({ contactId: this.availableContacts[i].id })
      }
    }
    this.addClientContactsModalLoading = true
    this.service.put(this.appConstants.endPoints.accreditationsEndPoint + this.accreditationItem.id + '/link-contacts', {}, selectedContacts)
      .pipe(finalize(() => {
        this.addClientContactsModalLoading = false
      })).subscribe(data => {
        this.addClientContactsModal.hide();
        this.getAccreditationContacts();
        this.toastr.success(this.translate.instant('administration_selectedContacts_areLinked_label'))
      },
        error => {
          this.errorService.errorHandling(error).then(res => {
            this.error = res;
          });
        });
  }

  @ViewChild('modifyClientContactsModal', { static: true })
  modifyClientContactsModal: any
  openModifyClientContactsModal(obj) {
    const newObj = JSON.stringify(obj);
    this.clientDetails = obj;
    this.modifyClientContactsModal.show()
  }
  updateContact() {
    let modelSchema = {
      emailAddress: this.clientDetails.contact.emailAddress,
      firstName: this.clientDetails.contact.firstName,
      lastName: this.clientDetails.contact.lastName,
      jobTitle: this.clientDetails.contact.jobTitle,
      prefixName : this.clientDetails.contact.prefixName,
      contactGenderType : {id:this.clientDetails.contact.contactGenderType.id}
    }
    this.modifyClientContactsModalLoading = true
    this.service.put(this.appConstants.endPoints.accreditationsEndPoint + this.accreditationItem.id + '/contacts/' + this.clientDetails.id, {}, modelSchema)
      .pipe(finalize(() => {
        this.modifyClientContactsModalLoading = false
      })).subscribe(data => {
        this.modifyClientContactsModal.hide();
        this.getAccreditationContacts();
        this.toastr.success(this.translate.instant('administration_contactUpdated_label'))
      },
        error => {
          this.errorService.errorHandling(error).then(res => {
            this.error = res;
          });
        });
  }

  deleteItem: any = {};
  @ViewChild(CommonDeleteModalComponent, { static: true })
  deleteClientContactConfirmModal: CommonDeleteModalComponent
  openDeleteClientContactConfirmModal(obj) {
    this.deleteItem = obj;
    this.deleteClientContactConfirmModal.open({ name: obj.contact.emailAddress }, '', this.translate.instant('administration_deleteCustomerContactWarning_label', {firstName: obj.contact.firstName,lastName: obj.contact.lastName}));
  }
  confirmDelete(e) {
    if (e) {
      this.deleteClientContactConfirmModal.isLoading = true
      this.service.delete(this.appConstants.endPoints.accreditationsEndPoint + this.accreditationItem.id + '/contacts/' + this.deleteItem.id, {})
        .pipe(finalize(() => {
          this.deleteClientContactConfirmModal.isLoading = false
        })).subscribe(data => {
          this.getAccreditationContacts();
          this.deleteClientContactConfirmModal.close();
          this.toastr.success(this.deleteItem.contact.firstName + this.translate.instant('administration_contactisDeleted_label'))
          this.deleteItem = {};
        },
          error => {
            this.errorService.errorHandling(error).then(res => {
              this.error = res;
            });
          });
    }
  }

  genderTypes:any=[];
  genderTypesLoading:boolean=false;
  getGenderTypes(){
      this.genderTypes = [];
      this.genderTypesLoading = true;
      let url = this.appConstants.endPoints.networkCrmEndpoint + 'admin/query-contact-gender-types'
      this.service
      .post(url,{},{pageNumber:1,pageSize:10})
      .pipe(finalize(() => {
          this.genderTypesLoading = false;
      }))
      .subscribe(data => {
          this.genderTypes = data && data.searchResults ? data.searchResults : [];
      }, error => {
          this.errorService.errorHandling(error).then(res => {
          this.error = res;
          });
      })
  }


  isSearchSectionDirty: boolean = false;
  checkIsModalDirty() {
    if (this.isSearchSectionDirty || this.addClientContactsModalForm.form.dirty) {
      dhtmlx.confirm({
        text: this.translate.instant('administration_youHaveUnsavedChanges_label'),
        ok: 'YES',
        cancel: 'NO',
        callback: (res) => {
          if (res) {
            this.addClientContactsModal.hide();
          }
          else { }
        }
      });
    }
    else
      this.addClientContactsModal.hide();
  }

}
